import React from "react";
import CacheProvider from "./Components/Shared/CacheProvider/CacheProvider";
import AppRouter from "./Navigation/AppRouter";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import './locales/i18n';
import { useTranslation } from "react-i18next";

function App() {
  const { i18n } = useTranslation();
  document.body.dir = i18n.dir();

  return (
    <CacheProvider>
      <AppRouter />
      <ToastContainer  limit={1} newestOnTop/>
    </CacheProvider>
  );
}

export default App;
